import FlipCard, { Face, Back } from './lib/FlipCard.js';
export default FlipCard;
export { Face, Back };